import { Injectable } from '@angular/core';
import { map, ReplaySubject } from 'rxjs';
import { TPSError } from '../api/api.models';
import { ExternalData } from './external-data.model';
import { LegacyDataNormalizerService } from './legacy-data-normalizer.service';

@Injectable({
  providedIn: 'root',
})
export class ExternalDataService {
  public $data = new ReplaySubject<ExternalData>(1);

  public $language = this.$data.pipe(map((data) => data.lang));
  public $stylesheetName = this.$data.pipe(map((data) => data.stylesheetName));
  public $appleButtonstyle = this.$data.pipe(map((data) => data.appleButtonstyle));
  public $googleButtonstyle = this.$data.pipe(map((data) => data.googleButtonstyle));
  public $useShortCardTokenForm = this.$data.pipe(map((data) => data.useShortCardTokenForm));
  public $use3DSCardTokenForm = this.$data.pipe(map((data) => data.use3DSCardTokenForm));
  public $useExpressCheckout = this.$data.pipe(map((data) => data.useExpressCheckout));
  public $panFormatting = this.$data.pipe(map((data) => data.panFormatting === 'enabled' || data.panFormatting === true));
  public $form = this.$data.pipe(map(data => data.form));
  public $placeholders = this.$data.pipe(map(data => data.placeholders ?? false));
  public $permissiveSubmitButton = this.$data.pipe(map(data => data.permissiveSubmitButton ?? false));
  public $showErrorMessages = this.$data.pipe(map(data => data.showErrorMessages ?? true));

  constructor(private legacyNormalizer: LegacyDataNormalizerService) {
    this.addListener();
  }

  sendParentSuccessResponse(body: any) {
    const response = JSON.parse(JSON.stringify(body));
    parent.postMessage(response, '*');
  }

  sendParentErrorResponse(body: TPSError, statusCode: number) {
    const response = JSON.parse(JSON.stringify(body));
    response['statusCode'] = statusCode;
    parent.postMessage(response, '*');
  }

  private addListener() {
    window.addEventListener('message', (event) => {
      if (!this.isValidEventData(event.data)) {
        return;
      }

      this.$data.next(this.legacyNormalizer.normalize(event.data));
    });
    parent.postMessage({ ready: true }, '*');
  }

  private isValidEventData(data: ExternalData) {
    return !!data.hmac && !!data.hmacFields && !!data.companyId;
  }
}
